export default {
  COMMON__MINUTES: '分',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: '修改',
    BUTTON__DELETE: '删除',
    MESSAGE_STATUS__DELETE: '删除',
    MESSAGE_MENU__DELETE: '删除',
    BUTTON__SAVE: '保存',
    BUTTON__CANCEL: '取消',
    BUTTON__CLOSE: '关闭',
    MODAL__CHANNEL_INFORMATION__UPLOAD: '上传',
    EDIT_PROFILE__IMAGE_UPLOAD: '上传',
    CHANNEL_LIST__TITLE: '渠道',
    CHANNEL_SETTING__HEADER__TITLE: '平台信息',
    MODAL__USER_LIST__TITLE: '成员',
    CHANNEL_SETTING__MEMBERS__TITLE: '成员',
    NO_MEMBERS: '(空平台)',
    NO_NAME: '(未知用户)',
    TOOLTIP__UNKOWN_USER: '(未知用户)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: '退出平台',
    BUTTON__INVITE: '邀请',
    MODAL__INVITE_MEMBER__SELECTED: '已选择',
    MODAL__CREATE_CHANNEL__SELECTED: '已选择',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: '平台名称',
    MODAL__INVITE_MEMBER__TITLE: '添加成员',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: '输入',
    MESSAGE_INPUT__PLACE_HOLDER: '输入',
    BUTTON__CREATE: '生成',
    MODAL__CREATE_CHANNEL__TITLE: '新房间',
    TRYING_TO_CONNECT: '正在连接...',
    USER_PROFILE__MESSAGE: '消息',
    USER_PROFILE__USER_ID: '使用者ID',
    EDIT_PROFILE__USERID_LABEL: '使用者ID',
    EDIT_PROFILE__TITLE: '我的个人资料',
    EDIT_PROFILE__IMAGE_LABEL: '头像',
    EDIT_PROFILE__NICKNAME_LABEL: '昵称',
    EDIT_PROFILE__THEME_LABEL: '暗色主题',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: '在该房间上无法聊天',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: '读到此处',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: '激活',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: '全部成员',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: '邀请使用者',
    MODAL__DELETE_MESSAGE__TITLE: '确定要删除这条消息吗？',
    MODAL__CHANNEL_INFORMATION__TITLE: '编辑房间信息',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: '房间图片',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: '输入姓名',
    TYPING_INDICATOR__IS_TYPING: '输入中...',
    TYPING_INDICATOR__ARE_TYPING: '输入中...',
    TYPING_INDICATOR__MULTIPLE_TYPING: '输入中...',
    TYPING_INDICATOR__AND: '还有',
    MESSAGE_STATUS__SENDING_FAILED: '无法发送消息',
    MESSAGE_STATUS__TRY_AGAIN: '请重试',
    MESSAGE_STATUS__OR: '或',
    PLACE_HOLDER__WRONG: '发生错误',
    PLACE_HOLDER__RETRY_TO_CONNECT: '重试',
    NO_TITLE: '无标题',
    TOOLTIP__AND_YOU: ', 还有我',
    TOOLTIP__YOU: '我',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(未知消息)',
    UNKNOWN__CANNOT_READ_MESSAGE: '无法读取该消息',
    MESSAGE_EDITED: '(已编辑)',
    PLACE_HOLDER__NO_CHANNEL: '开始新对话',
    MESSAGE_MENU__REPLY: '回复',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: '我',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: '回复',
    CHANNEL_SETTING__PROFILE__EDIT: '编辑',
    MESSAGE_MENU__COPY: '复制',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: '确认',
  SETTINGS__NONE: '无',
  SEARCH__USER_PLACEHOLDER: '用姓名/员工号/手机号码搜索',
  SEARCH__NO_USER_INFO: '任何用户信息.',
  LOGIN__EMAIL_OR_HP: '输入邮件或者手机号码',
  ELECTRON: {
    MENU_DELETE: '删除',
    MENU_VIEW: '查看',
    MENU_SIGN_OUT: '退出',
    MENU_SETTINGS: '设置',
    MENU_CLOSE: '关闭',
    MENU_SELECT_ALL: '选择全部',
    MENU_FILE: '文件',
    MENU_ABOUT: '{0} 信息',
    MENU_UPDATE: '确认更新',
    MENU_HIDE: '隐藏 {0}',
    MENU_HIDE_OTHERS: '隐藏其他App',
    MENU_SHOW_ALL: '显示所有',
    MENU_QUIT: '{0} 停止',
    MENU_NEW_CHANNEL: '新房间',
    MENU_UNDO: '取消执行',
    MENU_REDO: '重新执行',
    MENU_CUT: '剪切',
    MENU_PASTE: '粘贴',
    MENU_PASTE_AND_MATCH_STYLE: '粘贴格式',
    MENU_RELOAD: '重新导入',
    MENU_FORCE_RELOAD: '强制导入',
    MENU_FULL_SCREEN: '转换为全屏',
    MENU_RESET_ZOOM: '实际大小',
    MENU_ZOOM_IN: '扩大',
    MENU_ZOOM_OUT: '缩小',
    MENU_WINDOW: '窗口',
    MENU_MINIMIZE: '最小化',
    MENU_ZOOM: '最大化',
    MENU_HELP: '帮助',
    MESSAGE_UP_TO_DATE: '已是最新版本.',
    UPDATE_AVAILABLE: '有更新',
    MESSAGE_UPDATE_AVAILABLE: '可更新至最新版本.',
    MENU_EDIT: '编辑',
    MENU_COPY: '复制',
    UP_TO_DATE: '最新版本',
  },
  LOGIN__INSERT_EMAIL_HP: '请输入邮件地址或手机号码.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE: '如忘记密码，请在手机App重置密码.',
  LOGIN__INSERT_PASSWORD: '请输入密码.',
  LOGIN__PASSWORD_INFORMATION: '忘记密码了？',
  BEFORE: '变更前',
  ALERT__NO_ONE_SELECTED: '未选择员工.',
  BASIC__: {
    ERROR: '发生错误.<br/>请稍后重试.',
    MSG__: { INPUT: '请输入搜索语' },
    PWD_ALL_VALIDATION: '密码必须包含%1$@~%2$@字的英文大小写字母，数字和特殊符号.',
    RETRY: '重试',
    PASSWORD_RULE: '8-20个字符内的英文大小写字母，数字，特殊符号的组合',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: '查看我的上下班记录权限',
  },
  LOGOUT: '退出',
  COMMON__SECONDS: '秒',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: '取消编辑时，编辑的内容将不会被保存.',
      ARE_YOU_SURE_WANT_TO_STOP: '要取消编辑排班吗？',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: '没有添加的班次.' } },
  AWAY_TIME: '时',
  SETTINGS__CHANGE_LANGUAGE: '语言设置',
  SEARCH__MEMBER_PLACEHOLDER: '员工名/员工号/手机号',
  ' ': '设置为不使用时孕产妇管理功能将成为非激活状态，相关记录也将无法查询.',
  BASIC__UNKNOWN: '未知',
  LOGIN__SERVER_ALERT: '无法连接到服务器.',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: '无法更新平台消息.',
      LEAVE_CHANNEL: '无法退出平台.',
      CREATE_CHANNEL: '无法创建频道。',
    },
    FILE__: { MAXIMGSIZE: '已超出最大文件大小25MB.' },
    ALLOW_BROWSER_ALARM: '为了接收通知，请将浏览器设置内的通知更改为允许接收.',
    LABEL__: { SEARCH_MESSAGE: 'Search messages' },
    GUIDE__: { SEARCH_MESSAGE: 'Search for the message you want to find in {0}.' },
    BASIC__: { NO_SEARCH_RESULT: '没有结果.' },
  },
  INVITE__MEMBER_SELECTION: '选择成员',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: '所有参与者都可以看到更改的名称.',
  NOTICE: '通知',
  INVITE__CREATE: '生成',
  CHANNEL__LEAVE_THIS_CHANNEL: '确定要推出频道吗？',
  LOGIN__PASSWORD_FAIL_COUNT: '已输入{0}次错误密码.',
  LOGIN__FAIL_ALERT: '连续输入5次错误密码时，将维持5分钟锁定状态.',
  LOGIN__LOCK_STATE_ALERT: '因连续输入错误密码，已转为5分钟锁定状态.',
  LOGIN__RETRY_ALERT: '{0} 后, 请重试.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'ShoplChat密码与手机App密码相同.',
  SETTINGS__ALL_MESSAGES: '通知所有新消息',
  SETTINGS__ALARM_SOUND: '声音',
  SETTINGS__SOUND_ALARM: '通知',
  SETTINGS__LISTEN_ALARM_SOUND: '接听',
  ALERT__MAX_INVITE_MEMBER: '可以进入房间的最多人员为20,000名.',
  LOGIN__DEACTIVATED_ALERT: '管理者将聊天功能设置为非激活状态，因而无法登录.',
  LOGIN__SERVER_ALERT_CONTENTS: '网络不稳定无法登录. 请确认网络连接后重新尝试.',
  LOGIN__LOGOUT_ALERT: '已退出.',
  CHANNEL__EDIT_CHANNEL_NAME: '更改房间名称',
  SETTINGS__THEME: '主题',
  SETTINGS__LANGUAGE: '语言',
  SETTINGS__LIGHT_THEME: '浅',
  SETTINGS__DARK_THEME: '暗',
  SEARCH__CHANNEL_PLACEHOLDER: '员工姓名',
  CHANNEL__CONTACT: '1:1 聊天',
  BASIC: { LABEL: { MAXIMAGECNT: '图片最多可以上传{0}个.' } },
  LOGIN__LOGIN_FAILED: 'ID或密码输入错误.',
  FORGOT_PW: '忘记密码了吗？',
  BASIC__MAX_FORMAT_INPUT: '最多可以输入%@个字符.',
  SERVICE__COMING_SOON: '即将更新',
  LOGIN__GUIDE: '您可以通过应用账号进行登录.',
  MOBILE__: {
    ACCESS_PC: '请从PC端访问后台！',
    ACCESS_DESC_01: '后台服务最适配于PC环境.',
    ACCESS_DESC_02: '为了更好的用户体验，请从PC端访问.',
    ACCESS_PC_ONLY: '请从PC端访问.',
    GUIDE: '聊天功能只能在PC或手机App使用.',
  },
  CHANNEL__NO_CHAT_HISTORY: '没有对话记录',
  LOGIN: '登录',
  LOGIN__PASSWORD: '密码输入',
  SEARCH__NO_RESULT: '没有结果.',
  BASIC__SEARCH: '搜索',
};
